const ITEMS = [
  "RESEARCH USE ONLY",
  "NOT FOR HUMAN CONSUMPTION",
  ">99% PURITY",
  "THIRD-PARTY TESTED",
  "BATCH COA INCLUDED",
  "COLD-CHAIN LOGISTICS",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="compliance-marquee" className="relative border-y border-[#E4E4E7] bg-[#FFFFFF] py-5 overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono-clinical text-xs tracking-[0.3em] uppercase text-[#A1A1AA] mx-8 flex items-center gap-8"
              >
                {item}
                <span className="text-[#6D28D9]/50">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
